import type React from 'react';
import { toast } from 'react-toastify';
import { DefaultV2 } from '~/components/common/layouts/DefaultV2';
import { useMessageSummaries } from '~/hooks/useMessageSummaries';
import { ChatPagesContainer } from '~/components/common/chat/ChatPagesContainer';
import useItandiAccount from '~/hooks/useItandiAccount';
import { postTemporaryUnread } from '~/utils/api/deals/Message';
import { isSuccess } from '~/utils/api/api_handler';
import { UPDATE_TEMPORARY_UNREAD_MESSAGE } from '~/models/Message';
import { SERVER_ERROR_MESSAGE } from '~/constants/AppConst';

export const Page: React.FC = () => {
  const { data: messageSummaries, mutate: mutateMessageSummaries } =
    useMessageSummaries().index();
  const { data: account } = useItandiAccount().currentAccount();
  if (messageSummaries === null || account === null) {
    return null;
  }
  const handleTemporaryUnread = async (dealId: number): Promise<void> => {
    const result = await postTemporaryUnread(dealId);
    if (isSuccess(result)) {
      await mutateMessageSummaries?.();
      toast.success(UPDATE_TEMPORARY_UNREAD_MESSAGE);
      return;
    }
    toast.error(SERVER_ERROR_MESSAGE);
  };
  return (
    <DefaultV2>
      <ChatPagesContainer
        handleTemporaryUnread={handleTemporaryUnread}
        isAdmin={account.isAdmin}
      />
    </DefaultV2>
  );
};
